import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Breadcrumb UI — outputs visible breadcrumbs.
 * Schema is injected separately via JSON-LD.
 */
export default function Breadcrumbs({ items, testid = "breadcrumbs" }) {
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid={testid}
      className="overline text-[var(--iw-faint)] flex flex-wrap items-center gap-2 mb-8"
    >
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={it.href} className="flex items-center gap-2">
            {i === 0 && <Home size={11} className="text-[var(--iw-gold)]" />}
            {isLast ? (
              <span className="text-[var(--iw-gold)]">{it.label}</span>
            ) : (
              <Link
                to={it.href}
                className="hover:text-[var(--iw-gold)] transition-colors"
              >
                {it.label}
              </Link>
            )}
            {!isLast && (
              <ChevronRight size={11} className="text-[var(--iw-faint)]" />
            )}
          </span>
        );
      })}
    </nav>
  );
}
